import { Breadcrumb, Button, Col, Form, Input, message, Row } from "antd";
import { useState } from "react";
import { useDispatch } from 'react-redux';
import { authUserData } from "../../utils/Helper";
import { Link } from "react-router-dom";
import { ReactComponent as Back } from '../../Images/Back.svg';
import { changePassword } from "../../slices/user";

const ChangePassword = () => {
    const Id = authUserData()?.user_id;
    const [form] = Form.useForm();
    const [, setLoading] = useState(false);
    const dispatch = useDispatch();

    const handleSubmit = values => {
        const payload = {
            user_id: Id, // Ensure selectedUserId is set correctly
            current_password: values.current_password,
            new_password: values.new_password,
            confirm_password: values.confirm_password,
        };

        setLoading(true); // Start loading spinner

        dispatch(changePassword({ values: payload }))
            .unwrap()
            .then(result => {
                if (result.success) {
                    message.success('Password Change Successfully!');
                }
            })
              .catch(error => {
                    setLoading(false);
                    if (typeof error === 'object' && error !== null) {
                      const messages = [];
                      for (const key in error) {
                        if (Array.isArray(error[key])) {
                          messages.push(`${key}: ${error[key].join(', ')}`);
                        }
                      }
            
                      if (messages.length > 0) {
                        message.error(messages.join('; '));
                      } else {
                        message.error('An unknown error occurred.');
                      }
                    } else if (typeof error === 'string') {
                      message.error(error); // Handle string error
                    } else if (error instanceof Error) {
                      message.error(error.message); // Handle Error object
                    } else {
                      message.error('An unknown error occurred.');
                    }
                  })
            .finally(() => {
                setLoading(false); // Stop loading spinner
            });
    };

    return (
        <>
            <div>
            <div className="sticyaction">
            <div className="sticky-header">
                <div className="pagenamerow mb-0">
                    <h2>Change Password </h2>
                    <div className="bredcrumbwrp">
                        <Link to="/" className="back">
                            <Back /> BACK
                        </Link>
                        <Breadcrumb
                            items={[
                                { title: <Link to="/dashboard">Home</Link> },
                                { title: 'Change Password' }
                            ]}
                        />
                    </div>
                </div>  </div>  </div>
                <div className="formwrapper">
                <Form
                    onFinish={handleSubmit} // Handle form submission
                    form={form}
                    layout="vertical"
                    initialValues={{
                        current_password: '',
                        new_password: '',
                        confirm_password: '',
                        user_id: Id, // Ensure selectedUserId is set correctly
                    }}
                >
                    <div className="formrowsection m-0 pb-0" style={{border:'0'}}>
                        <Row gutter={16}>
                            <Col xs={24} sm={12} md={8} lg={6}>
                                <Form.Item
                                    name="current_password"
                                    label={
                                        <span
                                            style={{
                                                fontWeight: 'bold',
                                                fontSize: '14px',
                                                color: '#333',
                                            }}
                                        >
                                            Current Password:
                                        </span>
                                    }
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Please enter password',
                                        },

                                    ]}
                                >
                                    <Input.Password
                                        placeholder="Please enter your password"
                                        style={{
                                            borderRadius: '5px',
                                            height: '40px',
                                            fontSize: '14px',
                                        }}
                                    />
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={12} md={8} lg={6}>
                                <Form.Item
                                    name="new_password"
                                    label={
                                        <span
                                            style={{
                                                fontWeight: 'bold',
                                                fontSize: '14px',
                                                color: '#333',
                                            }}
                                        >
                                            New Password:
                                        </span>
                                    }
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Please enter a strong password',
                                        },
                                        {
                                            pattern:
                                                /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
                                            message:
                                                'Password must be at least 8 characters long, with at least one uppercase letter, one lowercase letter, one number, and one special character.',
                                        },
                                    ]}
                                >
                                    <Input.Password
                                        placeholder="Please enter your password"
                                        style={{
                                            borderRadius: '5px',
                                            height: '40px',
                                            fontSize: '14px',
                                        }}
                                    />
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={12} md={8} lg={6}>
                                <Form.Item
                                    name="confirm_password"
                                    label={
                                        <span
                                            style={{
                                                fontWeight: 'bold',
                                                fontSize: '14px',
                                                color: '#333',
                                            }}
                                        >
                                            Confirm Password:
                                        </span>
                                    }
                                    dependencies={['new_password']}
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Please confirm your password.',
                                        },
                                        ({ getFieldValue }) => ({
                                            validator(_, value) {
                                                if (
                                                    !value ||
                                                    getFieldValue('new_password') === value
                                                ) {
                                                    return Promise.resolve();
                                                }
                                                return Promise.reject(
                                                    new Error('Passwords do not match.'),
                                                );
                                            },
                                        }),
                                    ]}
                                >
                                    <Input.Password
                                        placeholder="Please confirm your password"
                                        style={{
                                            borderRadius: '5px',
                                            height: '40px',
                                            fontSize: '14px',
                                        }}
                                    />
                                </Form.Item>
                            </Col>
                            <Button
                                key="save"
                                type="primary"
                                style={{
                                    backgroundColor: '#123B66',
                                    border: 'none',
                                    fontWeight: 'bold',
                                    marginTop: '27px',
                                }}
                                onClick={() => form.submit()}
                            >
                                Update Password
                            </Button>,
                        </Row>
                    </div>
                </Form>
            </div></div>
        </>
    )
}
export default ChangePassword;
